/**
 * Default images and values for new user profiles
 */

export const DEFAULT_IMAGES = {
  // Imagen de perfil predeterminada (avatar genérico)
  PROFILE: 'https://firebasestorage.googleapis.com/v0/b/illustra-6ca8a.appspot.com/o/default_pic.png?alt=media&token=7e02672b-6c59-4018-88bb-667c99007af4',
  
  // Imagen de perfil específica para administradores
  ADMIN_PROFILE: 'https://firebasestorage.googleapis.com/v0/b/illustra-6ca8a.appspot.com/o/defaults%2Fadmin_profile.png?alt=media&token=admin-token',
  
  // Banner predeterminado (color sólido violeta)
  BANNER: null, // Usaremos un color sólido violeta en lugar de una imagen
  
  // Imagen de fondo predeterminada
  BACKGROUND: 'https://firebasestorage.googleapis.com/v0/b/illustra-6ca8a.appspot.com/o/defaults%2Fdefault_background.webp?alt=media&token=6c531aed-9c6b-4239-8b1d-4c78a046a15b',
  
  // Placeholder para servicios sin imagen
  SERVICE_PLACEHOLDER: 'https://firebasestorage.googleapis.com/v0/b/illustra-6ca8a.appspot.com/o/defaults%2Fservice-placeholder.jpg?alt=media&token=placeholder-token',
  
  POST_PLACEHOLDER: '/images/post-placeholder.jpg',
  USER_AVATAR: '/images/avatar-placeholder.jpg',
  SERVICE_COVER: '/images/service-placeholder.jpg',
  VIDEO_POSTER: '/images/video-poster.jpg'
};

// Colores predeterminados para usuarios nuevos
export const DEFAULT_COLORS = {
  PRIMARY: '#8b5cf6',  // Primario (morado de Illustra)
  SECONDARY: '#6366f1', // Secundario (azul/índigo)
  ACCENT: '#ec4899',   // Acento (rosa)
  GRADIENT_START: '#8b5cf6',
  GRADIENT_END: '#d946ef',
  BANNER: '#8b5cf6'    // Color violeta para banner por defecto
};

export const MAX_SIZES = {
  IMAGE: 10 * 1024 * 1024, // 10MB
  VIDEO: 20 * 1024 * 1024, // 20MB
  AVATAR: 10 * 1024 * 1024, // 10MB
  BANNER: 10 * 1024 * 1024, // 10MB
  GIF: 10 * 1024 * 1024, // 10MB (avatar/banner GIF)
  PROFILE_BACKGROUND: 20 * 1024 * 1024 // 20MB (video/image/gif fondo)
};

export const MEDIA_LIMITS = {
  MAX_MEDIA_COUNT: 4,
  MAX_VIDEO_DURATION: 300 // 5 minutos
};

export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536
}; 